import Button from '@platform-ui/button-latest';
import cn from 'classnames';
import React from 'react';
import { PollSchema } from 'schema';
import { ImageWithPreview } from '../../../../components/ImageWithPreview';
import Markdown from '../../../../components/Markdown';
import { StickyFooterButton } from '../../../../components/StickyFooterButton';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { inIframe } from '../../../../utils/location';
import { Title } from '../../Title';
import { ContentWrapper } from '../../Wrappers/ContentWrapper';
import { RootWrapper } from '../../Wrappers/RootWrapper';
import styles from './Welcome.module.css';

interface WelcomeProps {
  welcome: PollSchema.WELCOME_SIMPLE['data'];
  title: string | null;
  onClick: () => void;
}

export const Welcome = ({
  title: pollTitle,
  welcome: { image, breadcrumbs, title, text, cta, disclaimer, imageBackground },
  onClick,
}: WelcomeProps) => {
  const isPhone = useBreakpoint('phone');
  const buttonSize = isPhone ? 'l' : 'm';

  const hasTextContent = !!breadcrumbs || !!title || !!text;
  const showPollTitle = !!pollTitle && !inIframe();

  return (
    <div className={styles.container}>
      <RootWrapper className={styles.container}>
        {showPollTitle && <Title className={styles.pollTitle}>{pollTitle}</Title>}

        <ContentWrapper>
          {image && (
            <ImageWithPreview
              className={cn(styles.image, { [c(styles.imageWithText)]: hasTextContent })}
              image={image}
              background={imageBackground}
            />
          )}

          {hasTextContent && (
            <div>
              {breadcrumbs && <p className={styles.breadcrumbs}>{breadcrumbs}</p>}

              {title && <Markdown className={styles.title}>{title}</Markdown>}

              {text && <Markdown className={styles.text}>{text}</Markdown>}
            </div>
          )}
        </ContentWrapper>

        <StickyFooterButton>
          <footer className={cn(styles.footer, { [c(styles.iframe)]: inIframe() })}>
            <div className={styles.ctaButton}>
              <Button onClick={onClick} size={buttonSize} wide={isPhone}>
                {cta}
              </Button>
            </div>

            {disclaimer && <Markdown className={styles.footerText}>{disclaimer}</Markdown>}
          </footer>
        </StickyFooterButton>
      </RootWrapper>
    </div>
  );
};
